/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEqual } from 'lodash';
import { getObjectType, sanitizeImage, sanitizeQrCode, sanitizeTextObject } from './utils';
import BackgroundPanel from './BackgroundPanel.vue';
import TextboxPanel from './TextboxPanel.vue';
import QrCodePanel from './QrCodePanel.vue';
import ImagePanel from './ImagePanel.vue';

/**
 * @emits object-change object _id, type and data
 * @emits background-change backgroundId
 * @emits uploaded asset data
 * @emits remove-object object _id and type
 * @emits close-panel void
 */
const __vue_script__ = {
    name: 'BadgeEditorPanel',

    components: {
        BackgroundPanel,
        QrCodePanel,
        TextboxPanel,
        ImagePanel,
    },

    props: {
        currentBadgePage: {
            type: Object,
            required: true,
        },
        currentSelection: {
            type: Array,
            default: () => ([]),
        },
        currentPageDimensions: {
            type: Object,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        fontAssets: {
            type: Array,
            default: () => ([]),
        },
        imageAssets: {
            type: Array,
            default: () => ([]),
        },
        open: {
            type: Boolean,
            default: false,
        },
        preset: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            assetList: [],
            backgroundId: undefined,
            objectId: undefined,
            imageCache: new Map(),
            object: undefined,
            originalObject: undefined,
            type: undefined,
        };
    },

    watch: {
        currentBadgePage: {
            deep: true,
            immediate: true,
            handler(page) {
                this.backgroundId = page?.blocks?.background?.id;
            }
        },
        currentSelection: {
            deep: true,
            handler(selections = []) {
                const selection = selections.at(0);
                if (selection) {
                    this.type = getObjectType(selection);
                    this.object = this.prepareObject(this.type, selection);
                    this.originalObject = this.prepareObject(this.type, selection);
                    this.objectId = selection._id;
                } else {
                    this.object = undefined;
                    this.originalObject = undefined;
                    this.type = undefined;
                }
            }
        },
        object: {
            deep: true,
            handler(data) {
                if (!this.objectId || !this.type) return;
                if (isEqual(this.originalObject, data)) return;
                this.$emit('object-change', {
                    _id: this.objectId,
                    type: this.type,
                    data,
                });
                this.originalObject = this.prepareObject(this.type, data);
            }
        }
    },

    methods: {
        /**
         * @param {'text'|'qrcode'|'images'} type
         * @param {Record<string,string|number>} object
         */
        prepareObject(type, object) {
            if (type === 'text') {
                return sanitizeTextObject(object);
            }
            if (type === 'qrcode') {
                return sanitizeQrCode(object);
            }
            if (type === 'images') {
                return sanitizeImage(object);
            }
            console.error('[BadgeEditorPanel] prepareObject got an unsupported type', type, object);
        },

        onClosePanel() {
            this.$emit('close-panel');
        },

        /** @param {string} backgroundId */
        onBackgroundChange(backgroundId) {
            this.$emit('background-change', backgroundId);
        },

        /** @param {string} imageId */
        onImageChange(imageId) {
            this.$emit('image-change', imageId);
        },

        onDuplicate() {
            if (!this.type && !this.objectId) return;
            this.$emit('duplicate-object', { _id: this.objectId, type: this.type });
        },

        onRemove() {
            if (!this.type && !this.objectId) return;
            this.$emit('remove-object', { _id: this.objectId, type: this.type });
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{staticClass:"badge-editor-panel properties"},[(_vm.object && _vm.type === 'text')?_c('textbox-panel',{key:_vm.object._id,attrs:{"fontFaces":_vm.fontAssets,"page-dimensions":_vm.currentPageDimensions,"event":_vm.event,"preset":_vm.preset},on:{"close-panel":_vm.onClosePanel,"remove-object":_vm.onRemove,"duplicate-object":_vm.onDuplicate},model:{value:(_vm.object),callback:function ($$v) {_vm.object=$$v},expression:"object"}}):(_vm.object && _vm.type === 'qrcode')?_c('qr-code-panel',{attrs:{"event":_vm.event,"page-dimensions":_vm.currentPageDimensions},on:{"close-panel":_vm.onClosePanel,"remove-object":_vm.onRemove,"duplicate-object":_vm.onDuplicate},model:{value:(_vm.object),callback:function ($$v) {_vm.object=$$v},expression:"object"}}):(_vm.object && _vm.type === 'images')?_c('image-panel',{attrs:{"id":_vm.objectId,"image-assets":_vm.imageAssets,"event":_vm.event,"page-dimensions":_vm.currentPageDimensions,"preset":_vm.preset},on:{"close-panel":_vm.onClosePanel,"remove-object":_vm.onRemove,"image-change":_vm.onImageChange,"duplicate-object":_vm.onDuplicate},model:{value:(_vm.object),callback:function ($$v) {_vm.object=$$v},expression:"object"}}):_c('background-panel',{attrs:{"background-id":_vm.backgroundId,"image-assets":_vm.imageAssets,"event":_vm.event,"page-dimensions":_vm.currentPageDimensions},on:{"close-panel":_vm.onClosePanel,"background-change":_vm.onBackgroundChange}})],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BadgeEditorPanel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__